var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":_vm.align}},[(_vm.fotoPath)?_c('v-img',_vm._b({attrs:{"src":_vm.fotoPath}},'v-img',_vm.$attrs,false)):_c('v-img',_vm._b({attrs:{"src":require("../assets/no-image.png")}},'v-img',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }